import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DurationPicker } from 'FRONTEND/components/Calendar/AppointmentForm/DurationPicker';
import StepTemplate from 'FRONTEND/components/Calendar/AppointmentForm/StepTemplate';
import AppointmentSlotPicker from 'FRONTEND/components/Calendar/AppointmentSlotPicker';
import { pickDuration, pickSlot } from 'FRONTEND/reducers/bookingSlice';
import { selectExpertDefaultDuration } from 'FRONTEND/selectors/bookingSelectors';
import { LOCATION_APPOINTMENT_DEFAULT_DURATION, FormTypes } from 'FRONTEND/utils/constants';
import i18n from 'FRONTEND/utils/i18n';

export const SlotStep = ({
  isCompleted,
  isLocked = false,
  onStepClick = () => {},
  shouldReset = false,
  onStepCompleted = () => {},
  ...otherProps
}) => {
  const dispatch = useDispatch();
  const locale = useSelector((state) => state.user.locale);
  const selectedSlot = useSelector((state) => state.booking.selectedSlot);
  const isLocationForm = useSelector((state) => state.booking.formType === FormTypes.LOCATION_FORM);

  const defaultDuration = useSelector(selectExpertDefaultDuration);
  useEffect(() => {
    if (shouldReset) {
      dispatch(pickSlot({ slot: null }));
      dispatch(pickDuration({ desiredDuration: isLocationForm ? LOCATION_APPOINTMENT_DEFAULT_DURATION : defaultDuration }));
    }
  }, [shouldReset, defaultDuration]);

  // Duration management
  const desiredDuration = useSelector((state) => state.booking.desiredDuration);
  const handleDurationChange = (duration) => {
    dispatch(pickDuration({ desiredDuration: duration }));
  };

  // Slot management
  const handleSlotChange = (slot) => {
    dispatch(pickSlot({ slot }));
    onStepCompleted();
  };
  const selectedSlotStart = selectedSlot && dayjs(selectedSlot.startDate);

  return (
    <StepTemplate
      label={i18n._('Select a slot')}
      isLocked={isLocked}
      onEditClick={() => onStepClick()}
      isStepCompleted={selectedSlot && isCompleted}
      editText={selectedSlotStart ? selectedSlotStart.locale(locale).format('llll') : ''}
      {...otherProps}
    >
      {!isLocationForm &&
        (
          <div className='appointmentForm-line'>
            <DurationPicker desiredDuration={desiredDuration} defaultDuration={defaultDuration} onChange={handleDurationChange} label={i18n._('Appointment duration predefined by the practitioner')} />
          </div>
        )}
      <AppointmentSlotPicker
        onAppointmentBooked={handleSlotChange}
        appointmentDuration={desiredDuration}
      />
    </StepTemplate>
  );
};
